// activeOperationCount + currentOperation (FoDetailHeaderDto) -> Estado indicator text (H6/RN16.1,
// story 123 / MIC-4252, S282). Never picks an arbitrary operation as "the" current one when there
// is more than one active — R-19.
import { operationCodeAndName, operationNameLabel } from './operationNameLabel'

export const currentOperationLabel = (source) => {
  const count = (source && source.activeOperationCount) || 0
  const operation = (source && source.currentOperation) || {}

  if (count > 1) {
    return { key: '{{count}} operations in progress', values: { count }, operationText: '' }
  }

  if (count === 1) {
    // ⚠ La guarda anterior miraba `jobReferenceId !== undefined` y luego interpolaba `jobOrder` y
    // `name`, que no había mirado nadie: con `{jobReferenceId: 1913, jobOrder: null, name: null}`
    // —dato real de `ofref2p`— el rótulo salía "null - null". Se comprueba lo que se va a usar.
    // Y el fallback NO es "sin operación en curso": `count === 1` dice que SÍ hay una, y afirmar lo
    // contrario sería falso. Lo que no se sabe es cuál, y eso es lo que se dice.
    // ADDENDUM 17 (E23): N1 renombró `name` -> `code` y añadió un `name` nuevo casi siempre vacío.
    // Leer `name` como antes habría dejado la cabecera diciendo "Operación en curso" para TODAS las
    // órdenes, sin que nada fallara.
    // ADDENDUM 20 (E26): y ya NO se identifica por el código, sino por el que haya. La guarda mira
    // `identifier` y no `code` justamente por eso: con `code` vacío y nombre puesto, preguntar por
    // el código mandaría al camino de abajo una operación que SÍ sabemos nombrar.
    const { code, name, identifier, showsBoth } = operationCodeAndName(operation)
    if (identifier) {
      return { key: '', values: {}, operationText: showsBoth ? `${code} - ${name}` : identifier }
    }
    // Sin código NI nombre: queda el camino de antes, que aún sirve a las puertas no renombradas y
    // al caso de una operación sin ninguno de los dos.
    const label = operationNameLabel(operation, 'Operation in progress')
    return { key: label.key, values: label.values, operationText: label.text }
  }

  return { key: 'No operation in progress', values: {}, operationText: '' }
}
